<template>
  <div>
      <StockCard :direction="'OUT'" :types="types"></StockCard>
  </div>
</template>

<script>
import StockCard from './stockcard.vue'
export default {
  components: { StockCard },
  data(){
    return{
          types:[
                {
                    code:"DO_SO",
                    name:"DO_FROM_SO"
                },
                {
                    code:"DO",
                    name:"DELIVERY_ORDER"
                },
                {
                    code:"ADJUSTMENT",
                    name:"ADJUSTMENT"
                }
            ],
    }
  }
}
</script>